// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1JtQx","insightsList":"newBusinessInsightsMenu_insightsList__21ule","active":"newBusinessInsightsMenu_active__3flKG"};